<template>
  <v-sheet color="transparent" class="position-relative">
    <v-progress-circular
        :color="color"
        :value="progress"
        :indeterminate="loading"
        :size="typeof size==='undefined' ? 48 : size"
        width="2"
        rotate="-90"
        class="position-absolute"
    />
    <v-btn icon @click="$emit('click')">
      <slot name="default"/>
    </v-btn>
  </v-sheet>
</template>

<script>
export default {
  props: ['color','size','time','loading'],
  data: () => ({
    progress: 0,
    timer: null
  }),
  mounted() {
    this.progress = 0;
    this.timer = setInterval(()=>{
      if(!this.$tools.isDefined(this.loading)) {
        this.progress += 100 / (this.time / 250);
      }
    }, 250)
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
}
</script>
